var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 289"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3963",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 45,
    rx: 4.5,
    stroke: "#880CE8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.7252 12H13.2748C11.4689 12 10 13.4689 10 15.2748V31.3248C10 33.1307 11.4689 34.5996 13.2748 34.5996H34.7252C36.5311 34.5996 38 33.1307 38 31.3248V15.2748C38 13.4689 36.5311 12 34.7252 12ZM32.5474 15.2L24.0139 21.3207L15.735 15.2H32.5474ZM34.7252 31.4001H13.2748C13.2333 31.4001 13.2 31.3663 13.2 31.3254V17.3055L23.9861 25.2795L34.8006 17.5227V31.3254C34.8 31.3663 34.7662 31.4001 34.7252 31.4001Z",
    fill: "#880CE8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleMail);
export default __webpack_public_path__ + "static/media/purple_mail.5591bdc1974bc9ada7ba3b9ca40dc37a.svg";
export { ForwardRef as ReactComponent };